// TODO: consolidate with product page ratings

import React from 'react';
import classnames from 'classnames';
import EmptyStar from 'images/icons/stars/round-empty.svg?react-svg';
import HalfStar from 'images/icons/stars/round-half.svg?react-svg';
import Star from 'images/icons/stars/round-full.svg?react-svg';
import styles from './StarRating.mod.scss';

export default function StarRating({ rating, className }) {
  return (
    <div className={classnames(styles.starContainer, className)}>
      <StarItem rating={rating} star={1} />
      <StarItem rating={rating} star={2} />
      <StarItem rating={rating} star={3} />
      <StarItem rating={rating} star={4} />
      <StarItem rating={rating} star={5} />
    </div>
  );
}

function StarItem({ rating, star }) {
  const dimensions = { width: 9, height: 9 };
  return (
    <span className={styles.star}>
      {rating >= star ? (
        <Star {...dimensions} />
      ) : rating > star - 1 ? (
        <HalfStar {...dimensions} />
      ) : (
        <EmptyStar {...dimensions} />
      )}
    </span>
  );
}
